/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { SolutionTemplate } from "@/components/landing/solution-template";
import { generalContractingConfig } from "./general-contracting-config";

export function GeneralContractingPageClient() {
  return <SolutionTemplate config={generalContractingConfig} />;
}
